import { ReactComponent as CloudyIcon } from '../weather/cloudy.svg'
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
import { ReactComponent as PartlyCloudyIcon } from '../weather/partly-cloudy.svg'
import { ReactComponent as RainIcon } from '../weather/rain.svg'
import { ReactComponent as SleetIcon } from '../weather/sleet.svg'
// eslint-disable-next-line no-unused-vars
import { ReactComponent as SunnyIcon } from '../weather/sunny.svg'
import { ReactComponent as ThunderstormIcon } from '../weather/thunderstorm.svg'

const WeatherIcon = ({ code, big }) => {
  // Define un objeto para mapear los códigos a los íconos
  const iconMapping = {
    11: SunnyIcon,
    '11n': SunnyIcon,
    12: PartlyCloudyIcon,
    '12n': PartlyCloudyIcon,
    13: CloudyIcon,
    '13n': CloudyIcon,
    14: CloudyIcon,
    '14n': CloudyIcon,
    15: CloudyIcon,
    '15n': CloudyIcon,
    16: CloudyIcon,
    '16n': CloudyIcon,
    17: CloudyIcon,
    '17n': CloudyIcon,
    23: RainIcon,
    '23n': RainIcon,
    24: RainIcon,
    '24n': RainIcon,
    25: RainIcon,
    '25n': RainIcon,
    26: RainIcon,
    '26n': RainIcon,
    33: SleetIcon,
    '33n': SleetIcon,
    34: SleetIcon,
    '34n': SleetIcon,
    35: SleetIcon,
    '35n': SleetIcon,
    36: SleetIcon,
    '36n': SleetIcon,
    43: RainIcon,
    '43n': RainIcon,
    44: RainIcon,
    '44n': RainIcon,
    45: RainIcon,
    '45n': RainIcon,
    46: RainIcon,
    '46n': RainIcon,
    51: ThunderstormIcon,
    '51n': ThunderstormIcon,
    52: ThunderstormIcon,
    '52n': ThunderstormIcon,
    53: ThunderstormIcon,
    '53n': ThunderstormIcon,
    54: ThunderstormIcon,
    '54n': ThunderstormIcon,
    61: ThunderstormIcon,
    '61n': ThunderstormIcon,
    62: ThunderstormIcon,
    '62n': ThunderstormIcon,
    63: ThunderstormIcon,
    '63n': ThunderstormIcon,
    64: ThunderstormIcon,
    '64n': ThunderstormIcon,
    71: SleetIcon,
    '71n': SleetIcon,
    72: SleetIcon,
    '72n': SleetIcon,
    73: SleetIcon,
    '73n': SleetIcon,
  }

  const Icon = iconMapping[code] || CloudyIcon // Icono predeterminado

  return <Icon width={big ? '100px' : '50px'} height={big ? '100px' : '50px'} />
}

export default WeatherIcon
